import React from "react";
import { Box } from "@mui/system";
import { Controller } from "react-hook-form";
import { SubmitButton } from "../../components/form";
import {
  // Checkbox,
  // FormControlLabel,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import OutlinedInputComponent from "components/form/outlined-input/OutlinedInput.component";
import { useTranslation } from "react-i18next";

const LoginForm = ({
  errors,
  control,
  isSubmitting = false,
  handleSubmit = () => { },
}) => {
  const { t } = useTranslation()
  return (
    <Box component="form" noValidate onSubmit={handleSubmit} width={1}>
      <Controller
        name="username"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <OutlinedInputComponent
            type="email"
            label="Email"
            error={errors?.username}
            {...field}
          />
        )}
      />
      <Controller
        name="password"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <OutlinedInputComponent
            type="password"
            label="Password"
            error={errors?.email}
            {...field}
          />
        )}
      />

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
      >
        <Typography>
          <Link
            underline="none"
            variant="subtitle1"
            color="secondary"
            component={RouterLink}
            to="/forgot-password"
          >
            {t("Forgot password?")}
          </Link>
        </Typography>
      </Stack>

      <SubmitButton label={t('Login')} isSubmitting={isSubmitting} />
    </Box>
  );
};

export default LoginForm;
